
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export function ITSupport() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation({ threshold: 0.1 });

  const items = [
    {
      icon: 'ri-calendar-check-line',
      title: 'Planes de Abono Personalizados',
      desc: 'Adaptamos nuestros servicios a las necesidades específicas de tu empresa con planes mensuales flexibles',
    },
    {
      icon: 'ri-tools-line',
      title: 'Mantenimiento Preventivo',
      desc: 'Evita problemas antes de que ocurran con revisiones programadas y optimización constante',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Soporte Correctivo Inmediato',
      desc: 'Resolución rápida de incidencias para minimizar el tiempo de inactividad de tu negocio',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Escalabilidad en sus Negocios',
      desc: 'Soluciones que crecen con tu empresa, desde pequeños negocios hasta grandes parques informáticos',
    },
  ];

  return (
    <section className="py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(236,72,153,0.05),transparent_60%)]"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div ref={leftRef} className={`order-2 lg:order-1 anim-fade-left ${leftVisible ? 'visible' : ''}`}>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              <strong className="text-pink-400">Soporte IT</strong> para empresas y negocios
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Soluciones, abonos y <strong className="text-gray-100">mantenimiento preventivo/correctivo</strong>
            </p>
            <div className="space-y-4">
              {items.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 group"
                  style={{
                    opacity: leftVisible ? 1 : 0,
                    transform: leftVisible ? 'translateX(0)' : 'translateX(-30px)',
                    transition: `opacity 0.5s ease-out ${0.2 + index * 0.12}s, transform 0.5s ease-out ${0.2 + index * 0.12}s`,
                  }}
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-pink-400/10 border border-pink-400/20 rounded-lg flex-shrink-0 group-hover:bg-pink-400/20 group-hover:scale-110 transition-all duration-300">
                    <i className={`${item.icon} text-2xl text-pink-400`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-white mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div ref={rightRef} className={`order-1 lg:order-2 relative anim-fade-right ${rightVisible ? 'visible' : ''}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-pink-400/20 hover-lift">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20IT%20support%20team%20working%20in%20modern%20server%20room%20with%20rack%20mounted%20servers%20and%20network%20cables%20blue%20ambient%20lighting%20technicians%20monitoring%20systems%20enterprise%20data%20center%20environment%20high%20quality%20corporate%20photography&width=600&height=500&seq=30&orientation=portrait"
                alt="Soporte IT para empresas y negocios - mantenimiento preventivo y correctivo"
                title="Servicios de soporte técnico IT empresarial - STI"
                width="600"
                height="500"
                className="w-full h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950/30 to-transparent"></div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-48 h-48 bg-pink-400/10 border border-pink-400/20 rounded-2xl -z-10"></div>
            <div className="absolute -top-4 -left-4 w-48 h-48 bg-pink-400/5 border border-pink-400/10 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
